import React, { useState } from 'react';
import HeroSection from '../Hero/HeroSection';
import EpisodeRail from '../Episodes/EpisodeRail';
import FeaturedAdsSection from '../Ads/FeaturedAdsSection';
import ShortsRail from '../Shorts/ShortsRail';
import BlogSection from '../Blog/BlogSection';
import ExploreGrid from '../Explore/ExploreGrid';
import './home-template.css';

// Sonic Motion homepage. Section order was originally a literal match of
// the reference (.agent/templates/sonic-motion-reference.html): hero ->
// episodes -> sponsors -> shorts -> blogs -> explore. Sponsors has since
// been moved later (now blogs -> sponsors -> explore) by deliberate
// decision: at the top of the page, with the same visual weight as
// editorial content, it interrupted the "what is this -> listen now ->
// explore more" arc directly after the first content section. It still
// keeps id="sponsors" and the shared .a-section scroll-margin-top rule, so
// any existing #sponsors deep link still lands correctly after the reorder.
//
// "About This Episode" (TextColumn) is dropped from this pass — it isn't a
// section in the reference at all, and the explicit ask this round is exact
// structural fidelity to the reference over the earlier prose-spec
// judgment call to keep it. The component itself is untouched/still
// reusable elsewhere, just no longer rendered on the homepage.
//
// MailingListModal (exit-intent popup) was removed from here — it
// duplicated the Footer's newsletter form with a different, conflicting
// data contract (required first name + email vs. email-only). The Footer
// form is now the single newsletter capture point on every page.
const HomeTemplate = () => {
  const [, setCurrentEpisode] = useState(null);

  return (
    <div className="home-template">
      <section className="a-section a-section--hero" id="home">
        <div className="a-section-inner">
          <HeroSection onEpisodeLoad={setCurrentEpisode} />
        </div>
      </section>

      <section className="a-section a-section--episodes" id="episodes">
        <div className="a-section-inner">
          <EpisodeRail />
        </div>
      </section>

      <section className="a-section a-section--shorts" id="shorts">
        <div className="a-section-inner">
          <ShortsRail />
        </div>
      </section>

      <section className="a-section a-section--blogs" id="blogs">
        <div className="a-section-inner">
          <BlogSection />
        </div>
      </section>

      <section className="a-section a-section--sponsors" id="sponsors">
        <div className="a-section-inner">
          <FeaturedAdsSection />
        </div>
      </section>

      <section className="a-section a-section--explore" id="explore">
        <div className="a-section-inner">
          <ExploreGrid />
        </div>
      </section>
    </div>
  );
};

export default HomeTemplate;
